import React from 'react';
import { captureException } from '../../posthog';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    captureException(error, {
      $exception_source: 'react_error_boundary',
      react_component_stack: errorInfo?.componentStack || '',
    });
  }

  render() {
    const { hasError, error } = this.state;

    if (hasError) {
      if (this.props.fallback != null) {
        return this.props.fallback;
      }

      return (
        <div className="error-boundary">
          <div className="error-content">
            <h2>Something went wrong</h2>
            <p>We're sorry, but something unexpected happened. Our team has been notified.</p>
            <div className="error-actions">
              <button
                type="button"
                className="error-button primary"
                onClick={() => window.location.reload()}
              >
                Reload Page
              </button>
              <button
                type="button"
                className="error-button secondary"
                onClick={() =>
                  this.setState({ hasError: false, error: null })
                }
              >
                Try Again
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && (
              <details className="error-details">
                <summary>Error Details (Development)</summary>
                <pre>{error?.toString()}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
